
export default function BenefitsSection() {
  const benefits = [
    {
      icon: 'ri-heart-pulse-line',
      title: 'Réduction du Stress',
      description: 'Diminuez votre niveau de stress et retrouvez votre équilibre intérieur grâce à nos techniques de relaxation profonde.'
    },
    {
      icon: 'ri-body-scan-line',
      title: 'Soulagement Musculaire',
      description: 'Éliminez les tensions musculaires et les douleurs chroniques avec nos massages thérapeutiques ciblés.'
    },
    {
      icon: 'ri-mental-health-line',
      title: 'Bien-être Mental',
      description: 'Améliorez votre humeur et votre clarté mentale dans notre environnement apaisant et tropical.'
    },
    {
      icon: 'ri-drop-line',
      title: 'Circulation Sanguine',
      description: 'Stimulez votre circulation sanguine et lymphatique pour une meilleure santé générale.'
    },
    {
      icon: 'ri-moon-line',
      title: 'Qualité du Sommeil',
      description: 'Retrouvez un sommeil réparateur grâce à nos soins relaxants et techniques de détente.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Renforcement Immunitaire',
      description: 'Boostez votre système immunitaire naturellement avec nos soins holistiques.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-teal-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Les <strong>Bienfaits</strong> de nos <strong>Massages</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Découvrez comment nos <strong>soins de bien-être</strong> peuvent transformer votre quotidien 
            et améliorer votre qualité de vie en <strong>Guadeloupe</strong>.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center mb-6">
                <i className={`${benefit.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">{benefit.title}</h3>
              <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
        
        <div className="mt-16 bg-white rounded-2xl p-8 md:p-12 shadow-xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                Pourquoi Choisir <strong>Zen Wellness</strong> ?
              </h3>
              <div className="space-y-4">
                <div className="flex items-start space-x-4">
                  <div className="w-6 h-6 bg-teal-600 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <p className="text-gray-700">
                    <strong>Expertise locale</strong> : Connaissance approfondie des besoins spécifiques du climat tropical
                  </p>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-6 h-6 bg-teal-600 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <p className="text-gray-700">
                    <strong>Techniques variées</strong> : Massage suédois, deep tissue, pierres chaudes, réflexologie
                  </p>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-6 h-6 bg-teal-600 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <p className="text-gray-700">
                    <strong>Flexibilité</strong> : Services en centre ou à domicile selon vos préférences
                  </p>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-6 h-6 bg-teal-600 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <p className="text-gray-700">
                    <strong>Produits naturels</strong> : Huiles essentielles et cosmétiques bio de Guadeloupe
                  </p>
                </div>
              </div>
            </div>
            
            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/6120e1bd75eb782b7689a32b54e6a09d.jpg"
                alt="Massage thérapeutique professionnel en Guadeloupe"
                className="rounded-xl shadow-lg object-cover w-full h-80"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
